module.exports = __webpack_public_path__ + "img/knu_gallery4.0ffab253.jpg";